import { render } from "./010-Survey.vue?vue&type=template&id=79f36cb4&scoped=true"
import script from "./010-Survey.vue?vue&type=script&lang=js"
export * from "./010-Survey.vue?vue&type=script&lang=js"

import "./010-Survey.vue?vue&type=style&index=0&id=79f36cb4&lang=scss&scoped=true"
import "./010-Survey.vue?vue&type=style&index=1&id=79f36cb4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79f36cb4"]])

export default __exports__